<template>
	<div>
		<div class="f-regular f-12 f-c-midgrey">
			<img src="../../../../../assets/icon-sidebar/outlet-sidebar.svg" alt=""
			     class="m-r-4"
			     style="height: 13px; margin-top: -2px"
			/>
			{{ transaksi.nama_outlet }}
		</div>
		<div class="f-semi f-16 f-c-black m-d-12">
			{{ transaksi.idtransaksi }}
		</div>

		<SOProgressBar
			:percent="transaksi.persensatase_pengerjaan"
			:green="kondisiSudahDiambil(transaksi) || kondisiSudahDiantar(transaksi)"
			:blue="kondisiBelumDiambil(transaksi) || kondisiBelumDiantar(transaksi)"
			:yellow="transaksi.persensatase_pengerjaan < 100"
		/>

		<div class="d-flex-between-center align-items-start">
			<div class="d-inline">
<!--				<div class="f-regular f-14 f-c-black"-->
<!--				     v-if="transaksi.persensatase_pengerjaan === 100 && transaksi.status_ambil === 0"-->
<!--				>-->
<!--					{{ transaksi.persensatase_pengerjaan }}%<span class="f-regular f-14 f-c-midgrey">  •  Selesai, sudah diambil</span>-->
<!--				</div>-->
<!--				<div class="f-regular f-14 f-c-black"-->
<!--				     v-if="transaksi.persensatase_pengerjaan === 100 && transaksi.status_ambil !== 0"-->
<!--				>-->
<!--					{{ transaksi.persensatase_pengerjaan }}%<span class="f-regular f-14 f-c-midgrey">  •  Selesai, belum diambil</span>-->
<!--				</div>-->
<!--				<div class="f-regular f-14 f-c-black"-->
<!--				     v-if="transaksi.persensatase_pengerjaan < 100"-->
<!--				>-->
<!--					{{-->
<!--						(transaksi.persensatase_pengerjaan.toString().split(".").length > 1) ?-->
<!--							transaksi.persensatase_pengerjaan.toFixed(2) :-->
<!--							transaksi.persensatase_pengerjaan-->
<!--					}}%-->
<!--					<span class="f-regular f-14 f-c-midgrey">  •  Pengerjaan</span>-->
<!--				</div>-->

				<div class="f-regular f-14 f-c-black">
					{{ transaksi.persensatase_pengerjaan }}%  •  {{ transaksi.status_transaksi_format }}
				</div>

				<div class="f-regular f-13 f-c-midgrey">
					Dibuat oleh <span class="f-c-black"> {{ transaksi.nama_karyawan }}</span>
				</div>
				<div class="f-regular f-13 f-c-midgrey" v-if="transaksi.idtransaksi_lama">
					Menggantikan transaksi <span class="f-c-black"> {{ transaksi.idtransaksi_lama }}</span>
				</div>
			</div>
			<div class="f-semi f-14 f-c-blue" @click="statusTransaksi(transaksi.idtransaksi)">
				Lihat Status
			</div>
		</div>
	</div>
</template>

<script>
import SOProgressBar from "@/so-components/global/ui/SOProgressBar";

export default {
	name: "SOTransaksiDetailProgress",
	components: {
		SOProgressBar,
	},
	props: {
		transaksi: Object
	},
	computed: {
		isWhiteLabel() {
			return this.transaksi.transaksi_loyalty != null
		}
	},
	methods: {
		statusTransaksi(id) {
			this.$router.push("/transaksi/reguler/detail/status/" + id + `${this.isWhiteLabel ? `/${this.transaksi.transaksi_loyalty.id}` : ""}`)
		}
	}
}
</script>